import set from 'lodash/set';
import booleanConverter from '@/services/import/General/booleanConverter';
import formatDate from '@/services/general/formatIsoDate';
import moment from 'moment';
import { TIERS_SOUS_TYPE_CONFRERE } from '@/configuration/tiers/tiersConf';

export const typeLignes = ['Location', 'Tlpe', 'FraisPose', 'FraisTechnique', 'Honoraire'];
export const typeLigneDivers = ['Honoraire'];

export function generateRef(nom) {
  const regex = /\W/g;
  return (nom.replace(regex, '')).slice(0, 3).toUpperCase();
}

export function getSuffixedTypes(suffixe) {
  return typeLignes.map(type => suffixe + type);
}

export function isNoPropertie(value) {
  return value === '' || value === undefined || value === null;
}

export function isNameExist(input, nom, prenom) {
  return input?.toLowerCase().trim() === `${nom.trim()} ${prenom.trim()}`.toLocaleLowerCase().trim()
      || input?.toLowerCase().trim() === `${prenom.trim()} ${nom.trim()}`.toLocaleLowerCase().trim();
}

export function formatDateExcel(string) {
  return formatDate(moment(string, 'DD/MM/YYYY').toDate());
}

export function fillEasyData(item, data, banColumnAuto, intColumn, boolColumn) {
  const keys = Object.keys(data);
  // fait tout les columns facile
  for (let i = 0; i < keys.length; i += 1) {
    if (!banColumnAuto.includes(keys[i])) {
      if (boolColumn.includes(keys[i])) {
        set(item, keys[i], booleanConverter(data[keys[i]]));
      } else if (keys[i].startsWith('date')) {
        set(item, keys[i], formatDateExcel(data[keys[i]]));
      } else if (intColumn.includes(keys[i])) {
        const num = Number(data[keys[i]]);
        set(item, keys[i], num);
      } else {
        set(item, keys[i], data[keys[i]]);
      }
    }
  }
}

export function formatPourcentageToNumber(string) {
  if (typeof string !== 'string') return string;
  return Number(string?.replace('%', '')?.replace(',', '.') ?? 0);
}

export function findConfrere(fournisseurs, nomCommercial) {
  if (!nomCommercial) return null;
  return fournisseurs.find(
    f => f.sousTypes.includes(TIERS_SOUS_TYPE_CONFRERE)
    && f.nomCommercial.trim().toLowerCase() === nomCommercial.trim().toLowerCase(),
  );
}
